export class KbCookies {

    public static getCookie(name: string) {
        let dc = document.cookie;
        let prefix = name + "=";
        let begin = dc.indexOf("; " + prefix);
        let end;
        if (begin == -1) {
            begin = dc.indexOf(prefix);
            if (begin != 0) return null;
        } else {
            begin += 2;
            end = document.cookie.indexOf(";", begin);
            if (end == -1) {
                end = dc.length;
            }
        }
        return decodeURI(dc.substring(begin + prefix.length, end));
    }

    public static setCookie(cname: string, cvalue: any, exdays?: number) {
        let expires = null;
        if (exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            expires= "expires=" + d.toUTCString();
        }

        let domain = document.location.hostname.replace("www.", ".");
        domain = domain.replace("betaprod.", ".");
        domain = domain.replace("beta.", ".");
        document.cookie = cname + "=" + cvalue + ";" + (exdays ? expires : '') + ";path=/;domain=" + domain;
    }

    public static removeCookie(cname: string) {
        KbCookies.setCookie(cname, '', 0);
    }
}
